import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { isNullOrUndefined } from 'util';
import { JournalInsertModel, tJournalModel } from 'src/app/models/tJournalModel';
import {tRecurrJnlModel}from 'src/app/models/tRecurrJnlModel';
import {tRecurrJnlService} from 'src/app/services/tRecurrJnl.service';
import { AppSettings } from 'src/app/shared/AppSettings';
import { TranslateService } from '@ngx-translate/core';
import { ApiResultDialogService } from 'src/app/services/Non-Master/ApiResultDialog.service';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { DatePipe } from '@angular/common';
import { tEmployeeService } from 'src/app/services/tEmployee.service';
import { tEmployeeModel } from 'src/app/models/tEmployeeModel';
import { tPrescriptionHeadModel,tPrescriptionCopyHeadModel, tPrescriptionHeadModelWithPatientBPInfo,tPrescriptionDirectionsModel } from 'src/app/models/tPrescriptionHeadModel';
import { tConsultHeadModelWithPatientInfo, tConsultHeadModel, BillPayStatus } from 'src/app/models/tConsultHeadModel';
import { tPrescriptionLineModel_withStock,tPrescriptionCopyLineModel, tPrescriptionLineModel, tPrescriptionLineModel_withStock_withRemark} from 'src/app/models/tPrescriptionLineModel';
import { tPrescriptionService } from 'src/app/services/tPrescription.service';
import { tShopModel } from 'src/app/models/tShopModel';

import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
@Component({
  selector: 'app-new-pres-copy',
  templateUrl: './new-pres-copy.component.html',
  styleUrls: ['./new-pres-copy.component.css']
})
export class NewPresCopyComponent implements OnInit {
  TAG = "VoucherSaveComponent";
  @Input() dataSubmit1: tPrescriptionCopyHeadModel[];
  @Input() dataSubmit2: tPrescriptionCopyLineModel[];
 // saveData:tRecurrJnlModel[]=new Array();
  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private router: Router,
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    private recurrJnlService:tRecurrJnlService,
    private apiResultDialogService: ApiResultDialogService,
    public datePipe: DatePipe,
    public tPrescriptionService:tPrescriptionService,
    private tEmployeeService: tEmployeeService
  ) { }

  get f() { return this.editForm.controls; }
  editForm: FormGroup;
  today = new Date();
  onClick=false;
  submitted = false;
  ecTypeSelectList: tEmployeeModel[];
  doctorName="";
  ngOnInit() {
    this.getEC_AllowSelectList();
    this.editForm = this.formBuilder.group({
      jnlDate: this.datePipe.transform(this.today, 'yyyy-MM-dd'),
      recurrName: ['', [Validators.required]],
      clthTherapistID:[]
    });

    this.log.i(this.TAG, 'onSubmit success: ' + JSON.stringify(this.dataSubmit1) );
    this.log.i(this.TAG, 'onSubmit success: ' + JSON.stringify(this.dataSubmit2) );
  }
  cancel() {
    this.log.i(this.TAG, 'do cancel');
    this.activeModal.close('Close click');
  }
  confirm(){
    var AllUploadJSON=[];
    this.submitted = true;
    this.log.i(this.TAG,this.editForm.get('recurrName').value);
    if(this.onClick==false){
      this.onClick=true;
    if (this.editForm.valid) {



      var text=this.editForm.get('recurrName').value;
      var doctorID=this.editForm.get('clthTherapistID').value;
      this.log.i(this.TAG, text);
      this.inputRecurrName(text);
      this.inputDoctorID(doctorID)
      const AllUploadJSONRaw = {
        header: this.dataSubmit1,
        line: this.dataSubmit2
      };

      AllUploadJSON.push(AllUploadJSONRaw);


      this.log.i(this.TAG, JSON.stringify(AllUploadJSON));

      // return;
      // localStorage.setItem('tPrescriptionChange', 'N');

      this.tPrescriptionService.savePresCopy(AllUploadJSON)
        .subscribe(

          (data: any) => {
            // this.log.i(this.TAG, 'onSubmit success: ' + JSON.stringify(data) );

            let returnDisplayMsg: string;
            returnDisplayMsg=this.getTranslate("common_pres.message.submit_message")+' ';


            if(this.editForm.get('clthTherapistID').value=="0"){
               returnDisplayMsg+=this.doctorName;
            }else{
              returnDisplayMsg+=this.editForm.get('clthTherapistID').value;
            }
           

            this.cancel();
            this.onClick=false;
            this.apiResultDialogService.openDialog(MastersKeyStringValue.ACTION_YNDialog, null, status, returnDisplayMsg);
          },
          err => {
            this.onClick=false;
          });


    }
  }
  }
  inputRecurrName(recurrName:string){
    for(let i=0;i<this.dataSubmit1.length;i++){

      this.dataSubmit1[i].prescriptionName=recurrName;
    }

  }
  inputDoctorID(id:string){
    for(let i=0;i<this.dataSubmit1.length;i++){

      this.dataSubmit1[i].remark2=id;
    }
  }
  getEC_AllowSelectList() {
    // ecAllowSelectList
    this.tEmployeeService.getEmployeeTypeListCopyPres(NavigationComponent.selectedShopID, 5).subscribe(data => {
      // this.timeSlotList = data;
      // this.log.i(this.TAG, 'getEmployeeTypeList  = ' + JSON.stringify(data));
  
      this.ecTypeSelectList = [];
      var AllEmployee=new tEmployeeModel();
      AllEmployee.employeeChiName="All";
      AllEmployee.employeeID="0";
      AllEmployee.drCMP="All";
      //this.doctorName="All";

      //filter
      for (var i = 0; i < data.empolyeeList.length; i++) {
        //check need put
        var checkingEmployeeShopList: tShopModel[] = JSON.parse(data.empolyeeList[i].employeeRemark1);
  
        for (var p = 0; p < checkingEmployeeShopList.length; p++) {
          if (checkingEmployeeShopList[p].shopID == NavigationComponent.selectedShopID) {
            this.ecTypeSelectList.push(data.empolyeeList[i]);
            break;
          }
        }
  
      }
      this.ecTypeSelectList.push(AllEmployee);
      this.doctorName= this.ecTypeSelectList[0].employeeChiName;
      //set default ec
  
     //  this.defaultEC = data.defaultEmpolyee;
     //  if (this.defaultEC != null && this.defaultEC != undefined) {
        //(<FormControl>this.editForm.controls['clthTherapistName']).setValue(this.defaultEC.employeeChiName);
        (<FormControl>this.editForm.controls['clthTherapistID']).setValue(this.ecTypeSelectList[0].employeeID);
    //  }
      // this.ecTypeSelectList = data.empolyeeList;
    }, error => {
      this.log.i(this.TAG, 'error = ' + JSON.stringify(error));
    });
  
  }
  changeTherapistID() {
    this.log.i(this.TAG, "do changeTherapistID");
    for (let i = 0; i < this.ecTypeSelectList.length; i++) {
  
      if (this.ecTypeSelectList[i].employeeID == this.editForm.get('clthTherapistID').value) {
       // (<FormControl>this.editForm.controls['clthTherapistName']).setValue(this.ecTypeSelectList[i].employeeChiName);
        this.doctorName=this.ecTypeSelectList[i].employeeChiName
        break;
      }
    }
  
  
  }
  getTranslate(key: string) {
    var returnDisplayMsg: string = "";
    this.translate.get(key).subscribe((res: string) => {
      returnDisplayMsg = res;
    });
    return returnDisplayMsg;
  }
}
